export default "__VITE_ASSET__ctWtJoCu__"